import { gql, useMutation } from '@apollo/client'
import { Button } from '@mui/material'
import { Dataroom } from 'utils/__generated__/graphql'

import { DATAROOM_FRAGMENT } from '../constants'

const UPDATE_DATAROOM = gql`
  ${DATAROOM_FRAGMENT}
  mutation UPDATE_DATAROOM($id: ID!, $dataroom: DataroomInput!) {
    updateDataroom(id: $id, dataroom: $dataroom) {
      ...DataroomFragment
    }
  }
`

function Publish({ dataroom }: { dataroom: Dataroom }) {
  const [updateDataroom] = useMutation(UPDATE_DATAROOM)

  const handlePublish = () => {
    updateDataroom({
      variables: {
        id: dataroom.id,
        dataroom: { isPublished: !dataroom.isPublished },
      },
    })
  }

  return (
    <Button
      color={dataroom.isPublished ? 'error' : 'primary'}
      onClick={handlePublish}
      size="small"
    >
      {dataroom.isPublished ? 'Unpublish' : 'Publish'}
    </Button>
  )
}

export default Publish
